import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { INFO, PRIMARY } from '../../../constants/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      margin: theme.spacing(1, 2),
      border: `1px solid #E2E6EA`,
      borderRadius: 12,
      padding: theme.spacing(1),
      backgroundColor: 'white',
    },
    wrapperActive: {
      border: `1px solid red`,
    },
    avatar: {
      width: 64,
      height: 64,
      margin: theme.spacing(1),
    },
    header: {
      flex: 1,
      padding: theme.spacing(1),
      overflow: 'hidden',
    },
    title: {
      fontWeight: 'bold',
      color: INFO,
    },
    subtitle: {
      flex: 1,
      marginTop: theme.spacing(0.5),
      color: '#87888A',
    },
    bold: {
      fontWeight: 'bold',
      color: INFO,
    },
    adornment: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'start',
      padding: theme.spacing(1),
    },
    time: {
      fontSize: 12,
      color: '#87888A',
    },
    counter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: PRIMARY,
      width: 24,
      height: 24,
      borderRadius: 12,
      marginTop: theme.spacing(1.5),
      padding: 0,
      '& > *': {
        fontSize: 12,
        color: 'white',
      },
    },
  }),
);

export default useStyles;
